/**
 * 俄语（ru-RU）
 */

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: 'список',
    Platform: 'платформа',
    Store: 'магазин',
    ProductTitle: 'продукт',
    Tags: 'метка',
    Custom: 'обычай',
    Collections: 'коллекция',
    Description: 'описание',
    Variants: 'вариант',
    Images: 'изображение',
    listNow: 'Список сейчас',
    CancelEditing: 'Отменить редактирование',
    tips1: 'не более 40000 символов',
    tips2: 'Поддерживаются только изображения JPG, JPEG и PNG. ',
    ShippingMethod: 'вид транспорта ',
    Product: 'продукт',
    SKU: 'SKU',
    size: 'размер',
    color: 'цвет',
    ProductCost: 'себестоимость продукции',
    ShippingCost: 'фрахт ',
    CompareAtPrice: 'соотношение',
    SuggestedPrice: 'Рекомендуемая цена',
    Profi: 'прибыль',
    Quantity: 'количество',
    tips3: 'включая судоходные компании ',
    tips4: 'Поддержка до 250 изображений ',
    tips5: 'Поддержка до 40 изображений ',
    SuggestedPriceTips1: 'продажная цена = первоначальная цена * (1 + плюс) фрахт',
    CompareAtPriceTips1: 'сопоставление цен = себестоимость продукции * (1 + норма прибыли) + транспортные расходы',
    SuggestedPriceTips2: '(если вы выбрали "включая фрахт")',
    SuggestedPriceTips3: 'один щелчок может изменить все цены',
    NewPrice: 'новая цена',
    cancel: 'отмена',
    confirm: 'подтверждение',
    Percentage: 'процент',
    OneClickModification: 'изменение ключа',
    ProductionEditor: 'редактор продуктов ',
    SyncCollection: 'согласующее множество ',
    selectContent: 'выбор содержимого',
    ShippingFrom: 'Начало ',
    ShippingTo: 'конец ',
    EstimatedDeliveryTime: 'предполагаемое время поставки ',
    NoPictures: 'Нет фотографии',
    loadingText: 'Загрузка...',
    repeat: 'Повторяю!',
    IncorrectLogisticsInformation: 'способ отправки не может быть пустым',
    PictureCannotBeEmpty: 'Изображение не может быть пустым',
    SKUCannotBeEmpty: 'SKU не может быть пустым',
    inputLength: 'длина ниже 255 ',
    richTextCheck: 'количество слов с богатым текстом не должно превышать 40000 ',
    CompareAtPriceCheck: 'The compare at price must be higher than the suggested price ',
    CompareAtPriceCheckShoplazza: 'цена должна быть выше',
    titleCheck: 'Заголовок не может быть пустым',
    DescriptionCheck: 'Не показывать пустым',
    ShelfStatusUp: 'эта продукция будет продаваться заранее в магазине',
    ShelfStatusDowm: 'этот продукт был зарегистрирован в этом магазине раньше',
    ProfitMargin: 'норма прибыли',
    imageMaxLengthTips: 'выбрать только 250 фотографий ',
    imageMaxLengthTips2: 'выбрать только 40 фотографий ',
    tagLength: 'Максимальное количество вкладок',
    isFilterDuplicateSpuText: 'один и тот же продукт будет дублировать список',
    beenListed: 'неудача. Список объектов уже составлен.'
  },
  publishListings: {
    listings: 'список',
    Published: 'издать',
    Hidden: 'скрытый',
    ListingQueue: 'очередь списков',
    Deleted: 'Удалить',
    productSelected: 'выбор продукта',
    Product: 'продукт',
    ProductId: 'кодирование продуктов',
    priceScope: 'сфера цен',
    CompareAtPrice: 'соотношение',
    Inventory: 'запасы',
    EditProduct: 'редактировать продукцию',
    More: 'больше',
    Synchronous: 'синхронный',
    Relist: 'снова войти',
    PublishedIn: 'публиковать ...',
    Delete: 'Удалить',
    synType1Title: 'в списке...',
    synType5Title: 'О перезагрузке...',
    synType4Title: 'прятаться в магазине',
    synType10Title: 'синхронизация...',
    synType2Title: 'Синхронизировать редактирование информации...',
    noProduct: 'Извините, вы не добавили продукт',
    ChooseProduct: 'выбор продукции',
    ConnectANewStore: 'подключиться к новому магазину',
    hiddenComfirmTitle: 'Вы уверены, что хотите удалить продукт из магазина?',
    RelistComfirmTitle: 'Вы уверены, что хотите реинтегрировать продукт в магазин?',
    deleteComfirmTitle: 'Вы уверены, что хотите удалить продукт из вашего магазина?',
    synType3Title: 'Удалить...',
    searchBy: 'Поиск содержимого',
    SelectStore: 'выбор магазина',
    store: 'магазин',
    productName: 'наименование продукции'
  },
  productList: {
    wishList: 'список желаний',
    productList: 'Перечень продукции',
    Delete: 'Удалить',
    productSelected: 'выбор продукта',
    deleteTip1: 'Удалить выбранные продукты?',
    submit: 'представление',
    cancel: 'отмена',
    Description: 'описание',
    Inventory: 'запасы',
    Price: 'цена',
    ProductType: 'тип продукции',
    Action: 'Меры',
    Detail: 'деталь',
    more: 'больше',
    ListToStore: 'Сохранить список',
    customized: 'заказной',
    goodsInStock: 'товар на складе',
    tatusTips: 'этот продукт не доступен.',
    canFind: 'Простите, не могу найти ~ пожалуйста, проверьте снова',
    ItemNo: 'нумерация пунктов',
    contentPlaceholder: 'Введите ключевое слово',
    Listing: 'котировка',
    YourPrice: 'твоя цена',
    From: 'из',
    ShipTo: 'доставлять судно',
    Cancel: 'отмена',
    ListNow: 'Список сейчас',
    Platform: 'платформа ',
    Store: 'магазин ',
    ShipMyOdersMostTo: 'доставка заказа ',
    ShippingMethod: ' транспортный канал',
    logisticsTips: 'если вы выбрали место отгрузки, место получения и логистику в одном из каналов, вы должны выбрать все эти',
    batchPublishTips: 'загрузить до 100 списков за раз',
    storeTips: 'Можно загрузить только в 1 магазин одновременно',
    priceTips: 'ваша цена = цена * входной коэффициент (время ввода вместо тарифа).',
    shipTips: 'Выбранные модели логистики используются только для поддержки системы',
    ShippingMethodTips: 'необязательный (вы можете отрегулировать перед отправкой)',
    inputPlaceholder: 'Поиск содержимого',
    haveShelves: 'ошибка списка: содержит Недоступные элементы.',
    textareaPlaceholder: 'Разделённый запятыми или строками ',
    repeatListTip: 'один и тот же продукт будет дублировать список',
    repeatList: 'повторить список',
    priceRatioGT20Tip: ' ваша продукция на сервер будет загружена в 20 раз по продажам ',
    yourPrice: 'ваша цена'
  },
  batchTasks: {
    batchTasks: 'задача пакетной обработки',
    Status: 'позиция',
    contentPlaceholder: 'поиск ',
    Number: 'нумерация',
    StoreInformation: 'сведения о магазине ',
    ItemNo: 'нумерация пунктов',
    PublicationSituation: 'издательство',
    FailedToLoad: 'Не удаётся загрузить',
    Success: 'успех',
    uploading: 'загрузка',
    ListingFailed: 'ошибка Листинга',
    CreationTime: 'время создания',
    Pending: 'невыясненный',
    Processing: 'обработка',
    Completed: 'полный',
    contentPlaceholder2: 'поиск номера проекта',
    Platform: 'платформа',
    Store: 'магазин',
    Product: 'продукт',
    ReasonForFailure: 'причина неудачи',
    data: 'данные'
  }
}
